











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { GoogleBmAgent } from '../models/googleBmAgent';
import { VerificationStatus } from '../models/verificationStatus';
import { LaunchStatus } from '../models/launchStatus';
import { AgentTableRow } from '../models/agentTableRow';
import DataTableColumn from '@/shared/components/dataTable/dataTableColumn';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import GoogleBmAgentTestModal from '@/features/apps/googlebm/components/GoogleBmAgentTestModal.vue';
import GoogleBmVerificationModal from '@/features/apps/googlebm/components/GoogleBmVerificationModal.vue';
import GoogleBmLaunchModal from '@/features/apps/googlebm/components/GoogleBmLaunchModal.vue';
import GoogleBmEditAgent from './GoogleBmEditAgent.vue';
import GoogleBmCancelVerificationModal from './GoogleBmCancelVerificationModal.vue';
import GoogleBmUnlaunchModal from './GoogleBmUnlaunchModal.vue';
import Check from 'vue-material-design-icons/Check.vue';
import Flask from 'vue-material-design-icons/Flask.vue';
import Rocket from 'vue-material-design-icons/RocketOutline.vue';
import Close from 'vue-material-design-icons/Close.vue';

type ScreenType = 'edit' | 'test' | 'verify' | 'cancel' | 'launch' | 'unlaunch';

@Component({
	components: {
		DropDownMenu,
		GoogleBmAgentTestModal,
		GoogleBmVerificationModal,
		GoogleBmLaunchModal,
		GoogleBmCancelVerificationModal,
		GoogleBmEditAgent,
		GoogleBmUnlaunchModal,
		Check,
		Flask,
		Rocket,
		Close
	}
})
export default class GoogleBmAgentList extends Vue {
	@Prop() public value: GoogleBmAgent[];

	public selectedRow: AgentTableRow | null = null;
	public visibleScreen: ScreenType | null = null;

	public entryPoints: AgentTableRow[] = [];

	@Watch('value', { immediate: true })
	public handleValueChange() {
		this.entryPoints = [];
		if (this.value && this.value.length > 0) {
			this.mapAgents();
		}
	}

	public mapAgents() {
		this.value.forEach(agent => {
			this.entryPoints.push({
				...agent,
				locationName: 'N/A',
				locationId: '',
				verificationStatus: agent.verificationStatus,
				launchStatus: agent.launchStatus,
				rowType: 'agent'
			});
			if (agent.locations) {
				agent.locations.forEach(location => {
					this.entryPoints.push({
						...agent,
						locationName: location.displayName,
						locationId: location.id!,
						verificationStatus: location.verificationStatus,
						launchStatus: location.launchStatus,
						rowType: 'location'
					});
				});
			}
		});
	}

	public getColumns(): DataTableColumn[] {
		return [
			{
				display: 'Agent',
				name: 'displayName',
				clickable: true
			},
			{
				display: 'Location',
				name: 'locationName'
			},
			{
				display: 'Verification Status',
				name: 'verificationStatus'
			},
			{
				display: 'Launch Status',
				name: 'launchStatus'
			}
		];
	}

	public showScreen(screen: ScreenType, row: AgentTableRow) {
		this.selectedRow = row;
		this.visibleScreen = screen;
	}

	public hideScreen() {
		this.visibleScreen = null;
		this.selectedRow = null;
	}

	public isScreenVisible(screen: ScreenType) {
		return this.visibleScreen === screen;
	}

	public agentUpdated() {
		this.$emit('agentUpdated');
		this.hideScreen();
	}

	public getVerificationStatusMessage(status: VerificationStatus): string {
		switch (status) {
			case VerificationStatus.VERIFICATION_STATE_UNVERIFIED:
			case VerificationStatus.VERIFICATION_STATE_UNSPECIFIED:
				return 'Unverified';
			case VerificationStatus.VERIFICATION_STATE_VERIFIED:
				return 'Verified';
			case VerificationStatus.VERIFICATION_STATE_PENDING:
				return 'Pending';
			case VerificationStatus.VERIFICATION_STATE_SUSPENDED_IN_GMB:
				return 'Suspended';
			default:
				return 'Unverified';
		}
	}

	public getLaunchStatusMessage(status: LaunchStatus): string {
		switch (status) {
			case LaunchStatus.LAUNCH_STATE_UNLAUNCHED:
			case LaunchStatus.LAUNCH_STATE_UNSPECIFIED:
				return 'Unlaunched';
			case LaunchStatus.LAUNCH_STATE_LAUNCHED:
				return 'Launched';
			case LaunchStatus.LAUNCH_STATE_PENDING:
				return 'Pending';
			case LaunchStatus.LAUNCH_STATE_REJECTED:
				return 'Rejected';
			case LaunchStatus.LAUNCH_STATE_SUSPENDED:
				return 'Suspended';
			case LaunchStatus.LAUNCH_STATE_PENDING_UNLAUNCH:
				return 'Pending Unlaunch';
			default:
				return 'Unlaunched';
		}
	}

	public getVerificationStatusBadgeType(status: VerificationStatus): string {
		switch (status) {
			case VerificationStatus.VERIFICATION_STATE_UNVERIFIED:
			case VerificationStatus.VERIFICATION_STATE_UNSPECIFIED:
				return 'default';
			case VerificationStatus.VERIFICATION_STATE_VERIFIED:
				return 'success';
			case VerificationStatus.VERIFICATION_STATE_PENDING:
				return 'secondary';
			case VerificationStatus.VERIFICATION_STATE_SUSPENDED_IN_GMB:
				return 'danger';
			default:
				return 'default';
		}
	}

	public getLaunchStatusBadgeType(status: LaunchStatus): string {
		switch (status) {
			case LaunchStatus.LAUNCH_STATE_UNLAUNCHED:
			case LaunchStatus.LAUNCH_STATE_UNSPECIFIED:
				return 'default';
			case LaunchStatus.LAUNCH_STATE_LAUNCHED:
				return 'success';
			case LaunchStatus.LAUNCH_STATE_PENDING:
			case LaunchStatus.LAUNCH_STATE_PENDING_UNLAUNCH:
				return 'secondary';
			case LaunchStatus.LAUNCH_STATE_REJECTED:
			case LaunchStatus.LAUNCH_STATE_SUSPENDED:
				return 'danger';
			default:
				return 'default';
		}
	}

	public isVerificationPending(row: AgentTableRow) {
		if (row.rowType === 'location') {
			// Return false to hide option because locations cannot be unverified
			return false;
		}
		return row.verificationStatus === VerificationStatus.VERIFICATION_STATE_PENDING;
	}

	public isRowUnverified(row: AgentTableRow) {
		return (
			row.verificationStatus === VerificationStatus.VERIFICATION_STATE_UNVERIFIED ||
			row.verificationStatus === VerificationStatus.VERIFICATION_STATE_UNSPECIFIED
		);
	}

	public isRowReadyForLaunch(row: AgentTableRow) {
		return (
			row.verificationStatus === VerificationStatus.VERIFICATION_STATE_VERIFIED &&
			(row.launchStatus === LaunchStatus.LAUNCH_STATE_UNSPECIFIED || row.launchStatus === LaunchStatus.LAUNCH_STATE_UNLAUNCHED)
		);
	}

	public isRowLaunchedOrPending(row: AgentTableRow) {
		return row.launchStatus === LaunchStatus.LAUNCH_STATE_LAUNCHED || row.launchStatus === LaunchStatus.LAUNCH_STATE_PENDING;
	}
}
